<a
  [routerLink]="['/product', product.id]"
  class="group block overflow-hidden rounded-2xl border border-line bg-white transition hover:shadow-lg"
>
  <div class="relative aspect-[4/5] overflow-hidden bg-creamdark">
    <app-product-image
      [src]="product.images[0]?.url"
      [alt]="product.images[0]?.altText ?? product.title"
      [priority]="priority"
      [imgClass]="
        'h-full w-full object-cover transition duration-300 group-hover:scale-105' +
        (isSold() ? ' grayscale' : '')
      "
    />

    <div class="absolute left-3 top-3 flex flex-col gap-1.5">
      @if (isSold()) {
        <span class="rounded-full bg-rose/90 px-2.5 py-1 text-xs font-medium text-cream"
          >Recently Sold</span
        >
      } @else {
        <span class="rounded-full bg-forest/90 px-2.5 py-1 text-xs font-medium text-cream">
          Buyer Protected
        </span>
        @if (isNew()) {
          <span class="rounded-full bg-rose/90 px-2.5 py-1 text-xs font-medium text-cream"
            >New</span
          >
        }
      }
    </div>
    @if (isSold()) {
      <div class="absolute inset-0 bg-ink/10"></div>
    }

    <button
      type="button"
      class="cursor-pointer absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-ink transition hover:scale-105"
      [class.text-rose]="isSaved()"
      (click)="toggleSave($event)"
      [attr.aria-pressed]="isSaved()"
      aria-label="Save this saddle"
    >
      <svg
        viewBox="0 0 24 24"
        [attr.fill]="isSaved() ? 'currentColor' : 'none'"
        stroke="currentColor"
        stroke-width="1.5"
        class="h-4.5 w-4.5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
        />
      </svg>
    </button>
  </div>

  <div class="p-4">
    <p class="font-display text-lg font-semibold text-ink">
      {{ formatPriceCents(product.priceAmountCents, product.currency) }}
    </p>
    <p class="mt-1 truncate text-sm font-medium text-ink">{{ product.title }}</p>
    <p class="mt-0.5 text-xs text-ink/60">
      {{ formatCondition(product.condition) }} · {{ product.locationSuburb }},
      {{ product.locationState }}
    </p>
    <p class="mt-2 flex items-center gap-1 text-xs text-ink/55">
      <span class="truncate">
        {{ product.seller.firstName }} {{ product.seller.lastName.charAt(0) }}.
      </span>
      @if (product.seller.stripeChargesEnabled) {
        <span
          class="inline-flex shrink-0 items-center gap-0.5 font-medium text-forest"
          title="Verified seller"
        >
          <app-icon name="shield" svgClass="h-3 w-3" [strokeWidth]="2" />
          Verified
        </span>
      }
    </p>
  </div>
</a>
